/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function vibrate(options, context) {
    var _a;
    var api = 'dd.device.notification.vibrate';
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: function () { return ({ duration: 300 }); } });
}

export { vibrate as default };
